// extracted by mini-css-extract-plugin
export var accordionButton = "c_g";
export var accordionContainer = "c_f";
export var accordionContent = "c_l";
export var accordionItem = "c_j";
export var open = "c_k";
export var thickerTop = "c_h";